import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=0652e7d6&scoped=true&"
import script from "./Relatorio.vue?vue&type=script&lang=js&"
export * from "./Relatorio.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio.vue?vue&type=style&index=0&id=0652e7d6&prod&scoped=true&lang=css&"
import style1 from "./Relatorio.vue?vue&type=style&index=1&id=0652e7d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652e7d6",
  null
  
)

export default component.exports